import React, { useState } from 'react';

export default function CommentsTab({ user, updateUserData }) {
    const [comment, setComment] = useState('');
    const comments = [...(user?.comments || [])].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

    return (
        <div className='commentsTab'>
            <div className='commentsHeader'>
                <h3>
                    Internal Notes
                    <span>({comments.length})</span>
                </h3>
            </div>

            <div className='commentsTimeline'>
                {comments.length ? (
                    comments.map((item) => (
                        <div className='commentCard' key={item._id}>
                            <div className='commentTop'>
                                <div className='commentUser'>
                                    <div className='commentAvatar'>{item?.addedBy?.name?.charAt(0) || 'A'}</div>

                                    <div>
                                        <div className='commentNameRow'>
                                            <strong>{item?.addedBy?.name || 'Admin'}</strong>
                                        </div>

                                        <span className='commentDate'>{new Date(item.createdAt).toLocaleString()}</span>
                                    </div>
                                </div>
                            </div>

                            <div className='commentMessage'>{item.message}</div>
                        </div>
                    ))
                ) : (
                    <div className='emptyComments'>No internal notes yet.</div>
                )}
            </div>

            <div className='commentComposer'>
                <label>Add Internal Note</label>

                <textarea value={comment} onChange={(e) => setComment(e.target.value)} placeholder='Write note...' />

                <div className='composerFooter'>
                    {/* <div className='statusField'>
                        <label>Lead Status</label>

                        <select value={leadStatus} onChange={(e) => setLeadStatus(e.target.value)}>
                            <option>New</option>
                            <option>Interested</option>
                            <option>Follow Up</option>
                            <option>Booked</option>
                            <option>Closed</option>
                        </select>
                    </div> */}

                    <button
                        className='saveCommentBtn'
                        onClick={() => {
                            updateUserData({ comment });
                            setComment('');
                        }}
                    >
                        Save Comment
                    </button>
                </div>
            </div>
        </div>
    );
}
